import { http } from './client';

export type FinanceStatus = 'no_invoice' | 'unconfirmed' | 'queued' | 'failed' | 'sent';
export type FinanceFilters = {
  from: string; to: string; status: FinanceStatus | 'all'; search: string; page: number;
  coordinatorIds?: string; coordinatorMatch?: 'any' | 'all'; duplicates?: boolean; archivedOnly?: boolean;
};
export type InvoiceSending = {
  _id: string; number: string; configuration: string; createdAt: string | null;
  status: FinanceStatus; sentAt: string | null; lastAttemptAt: string | null;
  lastAttemptStatus: string | null; to: string[]; cc: string[];
};
export type FinanceShow = {
  _id: string; eventName: string; jobNumber: string; startDay: string; endDay: string;
  markedCompleted?: boolean; timezone: string; isArchived: boolean; isDuplicate?: boolean; approved: boolean; contactInformationId: string | null;
  assignedCoordinatorId: string[]; location: string; status: FinanceStatus; invoices: InvoiceSending[];
};
export type FinanceReport = {
  rows: FinanceShow[]; filters: FinanceFilters; scope: 'all' | 'mine'; generatedAt: string;
  summary: Record<FinanceStatus | 'total', number>;
  pagination: { page: number; pageSize: number; total: number; totalPages: number };
};

export const financialDashboard = {
  async list(filters: FinanceFilters): Promise<FinanceReport> {
    const { response, error } = await http<{ data: FinanceReport }>({ method: 'GET', url: 'dashboard/finance', params: filters, isToken: true });
    if (error || !response) throw new Error(error?.response?.data?.message || 'Could not load invoice follow-up.');
    return response.data.data;
  },
  async export(filters: FinanceFilters): Promise<void> {
    const { response, error } = await http<Blob>({ method: 'GET', url: 'dashboard/finance/export', params: filters, isToken: true, file: true });
    if (error || !response) throw new Error('Could not export invoice follow-up. Try refreshing or choosing a smaller date range.');
    const url = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = `ended-shows-${filters.from}-${filters.to}.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
  },
};
